/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Comparison_Previous_PeriodInputs */



/**
* | output |
* | --- |
* | "Previous period" |
*
* @param {Consumption_Comparison_Previous_PeriodInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_comparison_previous_period = /** @type {((inputs?: Consumption_Comparison_Previous_PeriodInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Comparison_Previous_PeriodInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Previous period")
	return /** @type {LocalizedString} */ ("Période précédente")
});